import { roles } from '@nxsys/store/constants';
import General from '../../../modules/employee/detail/General';

export const employeesMenuConfig = [
  {
    permittedRole: [roles.employee],
    path: '/general',
    element: <General />,
  },
];
